module.exports = __webpack_public_path__ + "static/img/05_03.2415907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fivep/05_03.png
// module id = nRe7
// module chunks = 1